import React, { useState, useEffect } from "react";
import apiClient from "../../lib/common/apiClient";

import { useTranslation } from "react-i18next";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";

function TkOutSourcingShipDoShipButton(props) {
    const { id, schema, onSelectMst, grid, refresh, onSuccess, onFailure, customizeErrorMsgCallback, ...others } =
        props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {
        setConfirmMsg(
            t("dialog.msg.confirm.doShip", {
                outSourcingShipId: onSelectMst.outSourcingShipId,
            })
        );
        setConfirmData({ outSourcingShipId: onSelectMst.outSourcingShipId });
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onApiSuccess = (result, schema) => {
        if (refresh) {
            refresh.refresh();
        }

        if (onSuccess) {
            onSuccess(result.data);
        }
    };

    const onApiFailure = (reason) => {
        if (onFailure) {
            onFailure(
                t("error.doShipFailure", {
                    reason: reason.response ? reason.response.data : JSON.stringify(reason),
                })
            );
        }
    };

    const onDoShipOk = () => {
        let url = `/api/${schema.name}/doShip/${onSelectMst.outSourcingShipId}`;

        let form = new FormData();
        let json = {};
        let deleted = {};

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        apiClient
            .put(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => onApiSuccess(result, schema))
            .catch((reason) => onApiFailure(reason));
    };

    return (
        <>
            <ActionButtonLayout onClick={onOpen} {...others}>
                {t("buttonName.doShip")}
            </ActionButtonLayout>
            <ConfirmDialog
                id={id + "-doShip-confirm-dialog"}
                title={schema ? t(`dialog.title.${schema.name}.doShip`) : ""}
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onDoShipOk}
                onCancel={onClose}
            />
        </>
    );
}

export default TkOutSourcingShipDoShipButton;
